export class QuantityUnit {
    id = null;
    name = null;
    code = null;
}